// extracted by css-extract-rspack-plugin
export default {"SkeletonTableRow":"eNGux","CacheableItemTable":"Cvvh3","currentTarget":"nnKPl","StrategyFormPanel":"YBAW_","ItemLink":"n2Fqx","CollectionLink":"DXVlH"};